import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  FacebookShareButton,
  WhatsappShareButton,
} from "react-share";

const SocialShare = ({text, url}) => {
    return (
        <div className="social-share">
          <FacebookShareButton url={url} >
            <FontAwesomeIcon icon={faFacebook} className="icon" />
          </FacebookShareButton>
          
          <a target="_blank" rel="noopener noreferrer" 
          href={"https://twitter.com/intent/tweet?text="+text+" "+url+" &via=FundacionMohme"}>
            <FontAwesomeIcon icon={faTwitter} className="icon" />
          </a>
          <WhatsappShareButton url={url}>
            <FontAwesomeIcon icon={faWhatsapp} className="icon" />
          </WhatsappShareButton>
        </div>
    );
};

export default SocialShare;